import { useParams } from 'react-router'

import type { GlMapRouteParams } from './types'

export const useMappingId = () => {
  const { mappingId } = useParams<GlMapRouteParams>()

  if (!mappingId) {
    throw new Error('No mapping ID was found')
  }

  return mappingId
}
